import { VoucherFormSection } from '../../Section';

import { SinceDate } from '../SinceDate';
import { UntilDate } from '../UntilDate';
import { Weekdays } from '../Weekdays';

const VoucherFormTravelPeriod = () => {
  return (
    <VoucherFormSection
      title='Travel period'
      subtitle='When the trip can happen.'
      inputs={
        <>
          <SinceDate />
          <UntilDate />
          <Weekdays />
        </>
      }
    />
  );
};

export default VoucherFormTravelPeriod;
